import * as React from 'react';
import _ from 'lodash';
import { Icon, Popup, TextArea, Flag, Label } from 'semantic-ui-react';
import Button from "../../../Button";
import { IMultiLineValue } from '../../../MultiLineColumn';
import { IDataTwoLanguageInput } from "../../VirtualizedTableInterfaces";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";

interface ShortTextCompareComponentProps {
    value: IDataTwoLanguageInput;
    onChange: (value: IDataTwoLanguageInput) => void;
    inEditMode: boolean;
    readOnly: boolean;
    t: reactI18Next.TranslationFunction;
    isSpecificPSL?: boolean;
    maintainedTextsIconColor?: SemanticCOLORS;
}

interface ShortTextCompareComponentState {
    triggerActionType: 'click' | 'hover';
}

export default class ShortTextCompareComponent extends React.PureComponent<ShortTextCompareComponentProps, ShortTextCompareComponentState> {
    constructor(props: ShortTextCompareComponentProps) {
        super(props);
        this.state = {
            triggerActionType: "click",
        };
        this.handlePopupOpen = this.handlePopupOpen.bind(this);
        this.handlePopupClose = this.handlePopupClose.bind(this);
        this.renderComparePopup = this.renderComparePopup.bind(this);
    }

    private handlePopupOpen() {
        if (this.state.triggerActionType !== 'hover') {
            this.setState({ triggerActionType: 'hover' });
        }
    }

    private handlePopupClose() {
        if (this.state.triggerActionType !== 'click') {
            this.setState({ triggerActionType: 'click' });
        }
    }

    private updateToOriginalText = (key: string) => {
        const props = this.props;
        if (!props.readOnly && props.inEditMode) {
            const currentValue = _.clone(props.value as IDataTwoLanguageInput);
            const originalValues = currentValue[key] && currentValue[key].originalValues ? currentValue[key].originalValues as IMultiLineValue : undefined;
            const value: string = originalValues && typeof originalValues.originalText === "string" ? originalValues.originalText : "";
            currentValue[key] = {
                flag: currentValue[key].flag,
                value: value || "",
                originalValues: currentValue[key].originalValues,
                isMaintenanceStep: currentValue[key].isMaintenanceStep
            };

            props.onChange(currentValue);
        }
    }

    private getIconColor = (key: string): SemanticCOLORS => {
        const props = this.props;
        const valueObj = props.value[key];
        const originalValues = valueObj && valueObj.originalValues ? valueObj.originalValues as IMultiLineValue : undefined;
        return originalValues && originalValues.text && originalValues.originalText && props.maintainedTextsIconColor
            ? props.maintainedTextsIconColor
            : 'grey';
    }

    private renderComparePopup(key: string) {
        const props = this.props;
        const valueObj = props.value[key];
        const originalValues = valueObj && valueObj.originalValues ? valueObj.originalValues as IMultiLineValue : undefined;

        if (
            originalValues &&
            originalValues.text !== originalValues.originalText
        ) {
            return (
                <Popup
                    key={key}
                    className="zIndex-9999"
                    position={"top center"}
                    onOpen={this.handlePopupOpen}
                    onClose={this.handlePopupClose}
                    on={this.state.triggerActionType}
                    trigger={
                        <Icon
                            name={"clone"}
                            color={this.getIconColor(key)}
                            disabled={!props.inEditMode || (props.isSpecificPSL && !(valueObj && valueObj.isSpecificOption))}
                        />
                    }
                    flowing={true}
                    hoverable={true}
                >
                    <div className='display--flex'>
                        <div className={"textCompareBlock"}>
                            <Label
                                basic={true}
                                className={"textCompareBlockLabel"}
                                content={valueObj && valueObj.isSpecificOption ? props.t("OPTIONS_VIEW:BM_OPTION_TEXT") : props.t("OPTIONS_VIEW:OPTION_BASIC_TEXT")}
                                icon={<Flag name={valueObj.flag} />}
                            />
                            <TextArea
                                className={"textCompareTextArea"}
                                fluid={"true"}
                                disabled={true}
                                value={originalValues && originalValues.originalText ? originalValues.originalText : ""} // Ensure value is never null
                            />
                        </div>

                        <div>
                            <Label
                                basic={true}
                                className={"textCompareBlockLabel"}
                                content={valueObj && valueObj.isSpecificOption ? props.t("OPTIONS_VIEW:SM_OPTION_TEXT") : props.t("OPTIONS_VIEW:OPTION_TEXT")}
                                icon={<Flag name={valueObj.flag} />}
                            />
                            <TextArea
                                className={"textCompareTextArea"}
                                fluid={"true"}
                                disabled={true}
                                value={originalValues && originalValues.text ? originalValues.text : ""} // Ensure value is never null
                            />
                        </div>
                    </div>
                    {(!props.isSpecificPSL || (props.isSpecificPSL && valueObj && valueObj.isSpecificOption)) && (
                        <Popup
                            position={"top center"}
                            trigger={
                                <Button
                                    label={
                                        valueObj && valueObj.isSpecificOption
                                            ? props.t("OPTIONS_VIEW:TAKE_OVER_BM_OPTION_TEXT")
                                            : props.t("OPTIONS_VIEW:TAKE_OVER_OB_TEXT")
                                    }
                                    icon={"copy"}
                                    className='width--100Percent'
                                    style={{ margin: '10px 0 0' }}
                                    disabled={!props.inEditMode || (valueObj && valueObj.isMaintenanceStep && props.readOnly)}
                                    onClick={() =>
                                        valueObj && valueObj.isMaintenanceStep && this.updateToOriginalText(key)
                                    }
                                />
                            }
                            defaultOpen={false}
                            openOnTriggerClick={valueObj && valueObj.isMaintenanceStep ? false : true}
                            inverted={true}
                            content={props.t("OPTIONS_VIEW:RESET_WORKFLOW_INFO_MSG")}
                        />
                    )}
                </Popup>
            );
        } else {
            return <div key={key} />;
        }
    }

    render() {
        const props = this.props;
        const keys = Object.keys(props.value);
        return (
            <>
                {keys.map(this.renderComparePopup)}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/twoLanguage/ShortTextCompareComponent.tsx